<template>
  <Modal
    ref="mergeDatasetModal"
    :title="'Copy Datasets'"
  >
    <template #modal-main>
      <form
        id="copy-form"
        class="form container scrollbar"
        novalidate
        @change="handleFormChange"
        @submit.prevent=""
      >
        <div class="copy-card">
          <h3>Source</h3>
          <div class="row">
            <div class="col-4 settings__control-group">
              <label class="required">Project</label>
              <select
                id="project-select"
                v-model="project"
                class="select"
                :disabled="lockSource"
                required
                @change="selectedSourceProjectChange(project)"
              >
                <option :key="'project-select-null'" disabled :value="null">
                  Select a Project
                </option>
                <option v-for="option in projectList" :key="`project-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-4 settings__control-group">
              <label class="required">Dataset</label>
              <select
                id="source-DS-select"
                v-model="sourceDS"
                class="select"
                :class="{error: hasError && !sourceParams.dataset_id}"
                :disabled="lockSource"
                required
              >
                <option :key="'source-select-null'" disabled :value="null">Select a Dataset</option>
                <option v-for="option in sourceDatasets" :key="`source-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div v-if="sourceDS && sourceDS.annotation_sets && sourceDS.annotation_sets.length > 0" class="col-4 settings__control-group">
              <label class="required">Annotation Sets</label>
              <!-- <select
                v-if="sourceDS && sourceDS.annotation_sets && sourceDS.annotation_sets.length > 0"
                v-model="sourceAnnset"
                class="select"
                :class="{error: hasError}"
                required
              >
                <option :value="null">No Source Set</option>
                <option v-for="option in sourceDS.annotation_sets" :key="`dest-anset-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select> -->
              <v-select
                v-if="sourceDS && sourceDS.annotation_sets && sourceDS.annotation_sets.length > 0"
                v-model="sourceAnnsets"
                :items="sourceDS.annotation_sets"
                density="compact"
                clearable
                multiple
                variant="outlined"
                hide-details="true"
                item-title="name"
                item-value="id"
                width="100%"
              >
                <template #prepend-item>
                  <v-list-item
                    title="Select All"
                    @click="toggleSelectAllAnnotationSets"
                  >
                    <template #prepend>
                      <v-checkbox-btn
                        :color="selectedSomeAnnotationSets ? 'indigo-darken-4' : undefined"
                        :indeterminate="selectedSomeAnnotationSets && !selectedAllAnnotationSets"
                        :model-value="selectedAllAnnotationSets"
                      />
                    </template>
                  </v-list-item>

                  <v-divider class="mt-2" />
                </template>
                <template #selection="{ item, index }">
                  <v-chip v-if="index < 2" :text="item.title" />

                  <span
                    v-if="index === 2"
                    class="text-grey text-caption align-self-center"
                  >
                    (+{{ sourceAnnsets.length - 2 }} others)
                  </span>
                </template>
              </v-select>
            </div>
          </div>
          <!-- <div class="row mt-3">
            <v-checkbox
              v-model="copyAnnSetForDuplicate"
              color="#250e81"
              :hide-details="true"
              :density="'compact'"
            >
              <template #label>
                <span class="checkbox-text-label">Copy Annotations For Duplicate Images</span>
                <SVGIcon
                  v-tooltip="`Normally, duplicate images and their annotations are not copied.
                  This option allows copying annotation for images that already exist in the destination.`"
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'info'"
                  class="help-icon"
                />
              </template>
            </v-checkbox>
          </div> -->
          <div class="row mt-1">
            <v-checkbox
              v-model="onlyAnnotations"
              color="#250e81"
              :hide-details="true"
              :density="'compact'"
              :disabled="!annotationTypes || !sourceAnnsets"
            >
              <template #label>
                <span class="checkbox-text-label">Copy Selected Annotation Types Only</span>
                <!-- <SVGIcon
                  v-tooltip="`Only selected annotation types will be copied.
                  'Copy Annotations For Duplicate Images' should be selected if destination is in the same dataset as source`"
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'info'"
                  class="help-icon"
                /> -->
                <SVGIcon
                  v-tooltip="`Only selected annotation types will be copied.`"
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'info'"
                  class="help-icon"
                />
              </template>
            </v-checkbox>
          </div>
          <div class="row mt-1">
            <v-checkbox
              v-model="validateImageInStorage"
              color="#250e81"
              :hide-details="true"
              :density="'compact'"
            >
              <template #label>
                <span class="checkbox-text-label">Validate Image in Storage</span>
                <SVGIcon
                  v-tooltip="`Only copy valid images found in storage (will take additional time)`"
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'info'"
                  class="help-icon"
                />
              </template>
            </v-checkbox>
          </div>
          <div v-if="onlyAnnotations" class="row ml-3 mt-1">
            <div class="col-12 annotation-grid">
              <v-checkbox
                v-for="(type,i) in annotationTypes"
                :key="i"
                v-model="filterTypes"
                color="#250e81"
                :hide-details="true"
                :density="'compact'"
                :value="type"
              >
                <template #label>
                  <span class="checkbox-text-label">{{ getTypeDisplayString(type) }}</span>
                </template>
              </v-checkbox>
            </div>
          </div>
          <!-- <div class="row mt-1">
            <v-checkbox
              v-model="copySequences"
              color="#250e81"
              :hide-details="true"
              :density="'compact'"
            >
              <template #label>
                <span class="checkbox-text-label">Copy Sequences Only</span>
                <SVGIcon
                  v-tooltip="`Copy all sequences in selected datasets. Copy Annotations For Duplicate Images and Copy Selected Annotation Types will be ignored if this option is selected.`"
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'info'"
                  class="help-icon"
                />
              </template>
            </v-checkbox>
          </div> -->
          <div v-if="showFilters" class="row mt-1">
            <div class="col-12">
              <v-expansion-panels
                v-model="panels"
                multiple
                class="mt-2"
              >
                <v-expansion-panel
                  value="description"
                >
                  <v-expansion-panel-title>
                    <h3>Source Dataset Filters</h3>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <DatasetFilter
                      v-model="datasetFilters"
                      :dataset="sourceDS"
                      :annotationSets="sourceDS.annotation_sets"
                      :labels="sourceDS.labels"
                      :types="sourceDS.annotation_types"
                      :zIndex="1001"
                    />
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <hr class="mt-3">
          <h3 class="destination-header">
            Destination
            <SVGIcon
              v-tooltip="`Select where to copy the data into. If no dataset is selected, a new dataset and annotation set, along with any group will be created.
              If no source annotation set is selected, no annotation sets will be created.`"
              class="help-icon"
              :iconName="'info'"
              :width="'24px'"
              :height="'24px'"
            />
          </h3>
          <div class="row">
            <div class="col-4 settings__control-group">
              <label class="required">Project</label>
              <select
                id="project-select"
                v-model="destProject"
                class="select"
                :disabled="lockSource"
                required
                @change="selectedDestProjectChange(destProject)"
              >
                <option :key="'project-select-null'" disabled :value="null">
                  Select a Project
                </option>
                <option v-for="option in destProjectList" :key="`project-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-4 settings__control-group">
              <label class="required">Dataset</label>
              <select
                id="dest-DS-select"
                v-model="destDS"
                class="select"
                :class="{error: hasError}"
                required
              >
                <option :value="null">New Dataset</option>
                <option v-for="option in destDatasets" :key="`dest-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div v-if="!destDS" class="col-4 settings__control-group">
              <label>New Dataset Name</label>
              <input
                v-model="newDatasetName"
                type="text"
                class="select"
                :placeholder="sourceDS ? `Copy of ${sourceDS.name}` : 'Enter new dataset name'"
              />
            </div>
            <!-- <div v-show="dataset.d.groups && dataset.d.groups.length > 0" class="col-3 settings__control-group">
                    <select
                      :id="`dest-group-select-${i}`"
                      v-model="dataset.group_id"
                      class="select"
                      required
                    >
                      <option :key="'destination-group-null'" :value="''">Ungrouped</option>
                      <option v-for="option in dataset.d.groups" :key="`destination-group-${option.id}`" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </div> -->
            <!-- <div v-if="destDS" class="col-4 settings__control-group">
              <label class="required">Annotation Set</label>
              <select
                v-if="destDS && destDS.annotation_sets && destDS.annotation_sets.length > 0"
                v-model="destAnnset"
                class="select"
                :class="{error: hasError}"
                required
              >
                <option :value="null">New Destination Set</option>
                <option v-for="option in destDS.annotation_sets" :key="`dest-anset-select-${option.id}`" :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div> -->
            <!-- <div class="col settings__control-group me-1">
                    <div class="percent-input">
                      <input
                        v-model="dataset.percent"
                        :min="0"
                        :max="100"
                        type="number"
                        class="random-input"
                        :class="{error: hasError && !isDestinationSplitValid}"
                        @change="changeSanitizer"
                        @input="inputSanitizer"
                      >
                      %
                      <IconButton
                        class="remove-dest-ds-button ms-3"
                        :icon="'close'"
                        :width="20"
                        :height="20"
                        @click="removeDestDS(dataset)"
                      />
                    </div>
                  </div> -->
          </div>
          <template v-if="destDS?.annotation_sets">
            <h3 class="destination-header">
              Destination Annotation Sets
              <SVGIcon
                v-tooltip="`Select where to copy the data into. If no dataset is selected, a new dataset and annotation set, along with any group will be created.
              If no source annotation set is selected, no annotation sets will be created.`"
                class="help-icon"
                :iconName="'info'"
                :width="'24px'"
                :height="'24px'"
              />
            </h3>
            <div>
              <div v-for="srcSet in sourceAnnsets" :key="srcSet.id" class="row annotation-set-map__row mt-1">
                <div class="col-4 settings__control-group">
                  <div class="settings__control-container" disabled><span>{{ sourceIdToAnnsetMap[srcSet].name }}</span></div>
                </div>
                <SVGIcon
                  :width="'20px'"
                  :height="'20px'"
                  :iconName="'arrow_forward'"
                />
                <div class="settings__control-group annotation-set-map__dest">
                  <select
                    :id="`dest-annset-select-${srcSet.name}`"
                    v-model="srcToDestAnnsetMap[srcSet]"
                    class="select"
                    required
                  >
                    <option :key="'project-select-null'" :value="''">
                      New Annotation Set ({{ sourceIdToAnnsetMap[srcSet].name }})
                    </option>
                    <option v-for="option in destDS.annotation_sets" :key="`dest-annset-select-${option.id}`" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </template>
          <template v-if="selectedImages?.length > 0">
            <hr class="mt-3">
            <h3>Files</h3>
            <div class="row">
              <div v-if="selectedImages && selectedImages.length > 0" class="col file-grid scrollbar">
                <div v-for="(img, i) in selectedImages" :key="`file-${i}`" class="file-grid__cell">
                  <span>{{ img.name }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </form>
      <div v-if="awaitMergerResult || message" class="row mb-3 result-container">
        <div v-if="awaitMergerResult" class="info">
          <div class="loader merger-loader" />
          <span><pre>This operation may take a few minutes.</pre></span>
        </div>
        <div v-if="message && !awaitMergerResult" class="result" :class="[success ? 'info' : 'error']">
          <span><pre>{{ message }}</pre></span>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <div>
          <button
            class="button modal-action-button"
            :class="{'button-spinner': isLoading}"
            :disabled="isLoading ? true : false || (destinationParams && destinationParams[0] === null)"
            @click="applyCopySequences"
          >
            Apply
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import IconButton from '@/components/IconButton.vue';
import { inputSanitizer, changeSanitizer } from '@/assets/js/utils';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import DatasetFilter from '@/components/DatasetComponent/DatasetFilters/DatasetFilter.vue';
import useAnnotationType from '@/composables/useAnnotationType.js';
import SVGIcon from '@/components/SVGIcon.vue';
import { useToast } from 'vue-toast-notification';
import useTaskModal from '@/composables/useTaskModal.js';
import 'vue-toast-notification/dist/theme-sugar.css';
import { event } from 'vue-gtag';

const $toast = useToast();

export default {
  name: 'DatasetCopyModal',
  components: {
    Modal,
    IconButton,
    DatasetFilter,
    SVGIcon,
  },
  props: {
    datasets: {
      type: Array,
      default: () => [],
    },
    source: {
      type: Object,
      default: () => {},
    },
    filters: {
      type: Object,
      default: null,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
    lockSource: {
      type: Boolean,
      default: false,
    },
    selectedImages: {
      type: Array,
      default: null,
    },
  },
  emits: [
    'clear-copy', 'copy-complete', 'copy-in-progress', 'confirm-copy',
  ],
  setup() {
    const {
      getTypeDisplayString,
    } = useAnnotationType();
    const {
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    } = useTaskModal();

    return {
      getTypeDisplayString,
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    };
  },
  data() {
    return {
      dataConnect: null,
      project: null,
      sourceDatasets: [],
      sourceDS: null,
      sourceGroup: null,
      sourceAnnset: null,
      sourceAnnsets: [],
      awaitMergerResult: false,
      success: false,
      message: "",
      random: 100,
      destDatasets: [],
      destProject: null,
      destDS: null,
      destAnnset: null,
      destAnnsets: [],
      panels: [],
      datasetFilters: {},
      copyAnnSetForDuplicate: false,
      onlyAnnotations: false,
      filterTypes: [],
      annotationTypes: null,
      isLoading: false,
      buttonText: null,
      srcToDestAnnsetMap: {},
      destProjectList: null,
      newDatasetName: "",
      validateImageInStorage: false,
    };
  },
  computed: {
    username() {
      return this.$store.state.user.user.username;
    },
    projectList() {
      return this.$store.state.projects.projectList;
    },
    hasError() {
      return this.message && !this.success;
    },
    sourceDatasetLabels() {
      const sourceDatasetLabels = this.sourceDS?.labels;
      if (sourceDatasetLabels) {
        return sourceDatasetLabels;
      }
      return [];
    },
    destinationParams() {
      const params = {};

      if (this.destProject) {
        params.project_id = this.destProject.id;
      }

      if (this.destDS) {
        params.dataset_id = this.destDS.id;
      }
      if (this.destAnnset) {
        params.dest_annotation_set_id = this.destAnnset.id;
      }
      return params;
    },
    sourceParams() {
      const params = {};

      if (this.sourceDS) {
        params.dataset_id = this.sourceDS.id;
      }
      if (this.sourceGroup) {
        params.dataset_group_id_src = this.sourceGroup.id;
      }
      // if (this.sourceAnnset) {
      //   params.source_annotation_set_id = this.sourceAnnset.id;
      // }
      if (this.sourceAnnsets) {
        // const annotation_set_map = Object.entries(this.srcToDestAnnsetMap).map(([key, value]) => [key, value === "" ? null : value]);
        const annotation_set_map = Object.fromEntries(
          Object.entries(this.srcToDestAnnsetMap).map(([key, value]) => {
            const parsedKey = parseInt(key, 10);
            const parsedValue = value === "" ? null : parseInt(value, 10);
            return [parsedKey, parsedValue];
          }),
        );
        params.annotation_set_map = annotation_set_map;
      }

      return params;
    },
    filterParams() {
      if (this.filters) {
        return this.filters;
      }

      const params = {
        images_filter: null,
        image_files_filter: null,
        annotations_filter: null,
        image_review_status_filter: null,
        image_tags_filter: null,
      };

      // Images filter
      const imagesFilter = {};
      if (this.datasetFilters.groupsFilter?.length > 0) {
        imagesFilter.group_ids = this.datasetFilters.groupsFilter;
      }
      params.images_filter = Object.keys(imagesFilter).length ? imagesFilter : null;

      // Image files filter
      const imageFilesFilter = {};
      if (this.datasetFilters.imageNameFilter?.length > 0) {
        imageFilesFilter.image_name = this.datasetFilters.imageNameFilter;
      }
      if (this.datasetFilters.timeRangeFilter) {
        imageFilesFilter.lower_time = this.datasetFilters.timeRangeFilter[0];
        imageFilesFilter.upper_time = this.datasetFilters.timeRangeFilter[1];
      }
      if (this.datasetFilters.dateRangeFilter) {
        if (this.datasetFilters.dateRangeFilter[0]) {
          imageFilesFilter.lower_date = new Date(this.datasetFilters.dateRangeFilter[0]).toISOString();
        }
        if (this.datasetFilters.dateRangeFilter[1]) {
          imageFilesFilter.upper_date = new Date(this.datasetFilters.dateRangeFilter[1]).toISOString();
        }
      }
      if (this.datasetFilters.cameraSourceFilter?.length > 0) {
        imageFilesFilter.image_sources = this.datasetFilters.cameraSourceFilter;
      }
      params.image_files_filter = Object.keys(imageFilesFilter).length ? imageFilesFilter : null;

      // Annotations filter
      const annotationsFilter = {};
      if (this.datasetFilters.confidenceRangeFilter) {
        annotationsFilter.lower_score = this.datasetFilters.confidenceRangeFilter[0];
        annotationsFilter.upper_score = this.datasetFilters.confidenceRangeFilter[1];
      }
      if (this.datasetFilters.annotationTypeFilter?.length > 0) {
        annotationsFilter.types = this.datasetFilters.annotationTypeFilter;

        if (this.datasetFilters.annotationTypeFilterInvert) {
          annotationsFilter.types_inverse = true;
        }
      }
      if (this.datasetFilters.annotationSetFilter?.length > 0) {
        annotationsFilter.annotation_set_ids = this.datasetFilters.annotationSetFilter.map((set) => set.id);
      }
      if (this.datasetFilters.imagesWithAnnotationSetFilter?.length > 0) {
        annotationsFilter.images_with_annotation_set_ids = this.datasetFilters.imagesWithAnnotationSetFilter.map((set) => set.id);
      }
      if (this.datasetFilters.annotationLabelFilter?.length > 0) {
        annotationsFilter.images_with_annotation_label_indexes = this.datasetFilters.annotationLabelFilter;
      }
      if (this.datasetFilters.boundingBoxSizeFilter) {
        Object.entries(this.datasetFilters.boundingBoxSizeFilter).forEach(([key, value]) => {
          if (key !== 'type' && value) {
            annotationsFilter[`${key}_${this.datasetFilters.boundingBoxSizeFilter.type}`] = value;
          }
        });
      }
      params.annotations_filter = Object.keys(annotationsFilter).length ? annotationsFilter : null;

      // Tags
      const imageTagFilter = {};
      if (this.datasetFilters.imageTagFilter && this.datasetFilters.imageTagFilter.length > 0) {
        params.image_tags_filter.tag_names = this.datasetFilters.imageTagFilter.map((tag) => tag.name);
      }
      params.image_tags_filter = Object.keys(imageTagFilter).length ? imageTagFilter : null;

      return params;
    },
    isDestinationSplitValid() {
      const destinationSum = this.chosenDestDatasetAnnset.map((dest) => dest.percent).reduce((a, b) => a + b, 0);
      if (destinationSum > 100) {
        return false;
      }
      return true;
    },
    selectedAllAnnotationSets() {
      return this.sourceAnnsets.length === this.sourceDS.annotation_sets.length;
    },
    selectedSomeAnnotationSets() {
      return this.sourceAnnsets.length > 0;
    },
    sourceIdToAnnsetMap() {
      return this.sourceDS.annotation_sets.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    destIdToAnnsetMap() {
      return this.destDS.annotation_sets.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    sequences() {
      if (this.selectedImages) {
        const sequenceIds = this.selectedImages.filter((obj) => obj.frame_no === -1 && obj.sequence_id !== null).map((obj) => obj.sequence_id);
        return [...new Set(sequenceIds)];
      }
      return [];
    },
    images() {
      if (this.selectedImages) {
        const imageIds = this.selectedImages.filter((obj) => obj.frame_no > -1 || !obj.sequence_id).map((obj) => obj.id);
        return [...new Set(imageIds)];
      }
      return [];
    },
  },
  watch: {
    sourceDS: {
      deep: true,
      async handler() {
        if (this.sourceDS) {
          this.getAnnotationTypes(this.sourceDS.id);
          if (this.sourceDS.annotation_sets && this.sourceDS.annotation_sets.length > 0) {
            this.sourceAnnsets = this.sourceDS.annotation_sets.map((i) => i.id);
          }
          if (!this.destDS) {
            this.newDatasetName = this.getDefaultNewDatasetName(this.sourceDS);
          }
        }
      },
    },
    destDS: {
      deep: true,
      async handler() {
        this.srcToDestAnnsetMap = {};
        this.updateSrcToDestAnnsetMap();
        if (!this.destDS && this.sourceDS && !this.newDatasetName) {
          this.newDatasetName = this.getDefaultNewDatasetName(this.sourceDS);
        }
        // if (this.destDS) {
        //   if (this.destDS.annotation_sets && this.destDS.annotation_sets.length > 0) {
        //     this.destAnnset = this.destDS.annotation_sets[0];
        //   }
        // }
      },
    },
    // copySequences() {
    //   if (this.copySequences) {
    //     if (this.chosenDestDatasetAnnset.length > 0) {
    //       const temp = [...this.chosenDestDatasetAnnset];
    //       this.chosenDestDatasetAnnset = [temp[0]];
    //     }
    //   }
    // },
    sourceAnnsets: {
      deep: true,
      handler() {
        this.updateSrcToDestAnnsetMap();
      },
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  async mounted() {
    if (this.source) {
      this.project = this.projectList.find((p) => p.id === this.source.project_id);

      this.getWritableProjectList()
        .then((destProjects) => {
          this.destProjectList = destProjects;
          const target = this.destProjectList.find((p) => p.id === this.source.project_id);
          if (target) {
            this.destProject = target;
            this.destDatasets = this.datasets;
          } else {
            this.destProject = this.destProjectList[0];
            this.selectedDestProjectChange(this.destProject);
          }
        });

      this.sourceDatasets = this.datasets;
      this.sourceDS = this.sourceDatasets.find((ds) => this.source.id === ds.id);
      if (this.sourceDS && this.sourceDS.annotation_sets && this.sourceDS.annotation_sets.length > 0) {
        this.sourceAnnsets = this.sourceDS.annotation_sets.map((i) => i.id);
      }
      if (this.sourceDS && this.sourceDS.id) {
        this.getAnnotationTypes(this.sourceDS.id);
      }
    }
  },
  methods: {
    inputSanitizer,
    changeSanitizer,
    getDefaultNewDatasetName(dataset) {
      return dataset?.name ? `Copy of ${dataset.name}` : '';
    },
    async getAnnotationTypes(ds_id) {
      await this.dataConnect.getDatasetAnnotationTypes({ dataset_id: ds_id })
        .then((resp) => {
          if (resp.error) {
            throw resp.error;
          }
          this.annotationTypes = resp.result;
          this.filterTypes = resp.result;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getWritableProjectList() {
      return this.dataConnect.getProjectList({ only_writable: true })
        .then((data) => {
          if (data.error) {
            throw data.error;
          }
          return data.result;
        })
        .catch((e) => { console.log(e); });
    },
    async getDatasets(project) {
      const params = {
        project_id: project.id,
        get_annotation_sets: true,
        get_labels: true,
        get_groups: true,
      };
      const resp = await this.dataConnect.getDatasetList(params)
        .catch((error) => {
          // TODO: handle error
          console.log(error);
        });
      if (!resp || resp.error || !resp.result) {
        // TODO: handle error
        if (resp.error) console.error(resp.error);
        return [];
      }
      return resp.result;
    },
    async selectedSourceProjectChange(p) {
      if (p) {
        this.sourceDS = null;
        this.sourceAnnset = null;
        this.sourceAnnsets = [];
        this.sourceDatasets = await this.getDatasets(p);
      }
    },
    async selectedDestProjectChange(p) {
      if (p) {
        this.destDS = null;
        this.destAnnset = null;
        this.newDatasetName = "";
        this.destDatasets = await this.getDatasets(p);
      }
    },
    showModal() {
      this.$refs.mergeDatasetModal.showModal();
    },
    closeModal() {
      this.$refs.mergeDatasetModal.closeModal();
    },

    async applyCopySequences() {
      if (this.images.length > 0) {
        this.filterParams.images_filter.image_ids = this.images;
      }
      if (this.sequences.length > 0) {
        this.filterParams.images_filter.sequence_ids = this.sequences;
      }

      const params = {
        // dest: this.destinationParams,
        ...this.sourceParams,
        ...this.filterParams,
        // should_copy_annset_for_duplicate: this.copyAnnSetForDuplicate,
      };

      if (!this.sourceParams.dataset_id) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error: Error: Please select Source dataset`,
          type: "error",
          position: "top",
        });
        return;
      }

      if (this.filterTypes && this.filterTypes.length > 0) {
        params.filter_types = this.filterTypes;
      }

      this.isLoading = true;
      const copyParams = {
        ...params,
        sequences: [],
        dest_dataset_id: this.destinationParams.dataset_id,
        dest_annotation_set_id: this.destinationParams.dest_annotation_set_id,
        dest_project_id: this.destinationParams.project_id,
      };
      if (!this.destDS && this.newDatasetName) {
        copyParams.dest_dataset_name = this.newDatasetName;
      }
      if (this.validateImageInStorage) {
        copyParams.omit_missing_images = true;
      }
      await this.dataConnect.copySequences(copyParams)
        .then((resp) => {
          if (resp.error !== undefined) {
            throw Error(resp.error.message);
          } else if (resp.result) {
            this.isLoading = false;
            if (resp.result.duplicate_image_count > 0) {
              this.$emit('confirm-copy', {
                duplicate_count: resp.result.duplicate_image_count,
                fullParams: {
                  ...params,
                  sequences: [],
                  dest_dataset_id: this.destinationParams.dataset_id,
                  dest_annotation_set_id: this.destinationParams.dest_annotation_set_id,
                  dest_project_id: this.destinationParams.project_id,
                },
              });
            } else {
              if (!this.destDS) {
                $toast.open({
                  queue: true,
                  duration: 5000,
                  message: `Copying in progress.`,
                  type: "success",
                  position: "top",
                });
              } else {
                $toast.open({
                  queue: true,
                  duration: 5000,
                  message: `Copying in progress.`,
                  type: "success",
                  position: "top",
                });
              }

              this.getTasks();
              if (!this.isGettingTasks) {
                this.resumeGetTasks();
              }
              this.$emit('copy-in-progress', this.destDS, this.destProject);
              event('copy_dataset_success', {
                category: 'copy_dataset',
                label: 'User successfully copied a dataset',
                user: this.username,
              });
              this.closeModal();
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          event('copy_dataset_failure', {
            category: 'copy_dataset',
            label: error.message,
            user: this.username,
            reason: error.message,
          });
          $toast.open({
            queue: true,
            duration: 5000,
            message: error.message,
            type: "error",
            position: "top",
          });
          this.closeModal();
        });
    },
    clearMessage() {
      this.success = false;
      this.message = "";
    },
    handleFormChange() {
      this.clearMessage();
    },
    toggleSelectAllAnnotationSets() {
      if (this.selectedAllAnnotationSets) {
        this.sourceAnnsets = [];
      } else {
        this.sourceAnnsets = this.sourceDS.annotation_sets.slice().map((i) => i.id);
      }
    },
    updateSrcToDestAnnsetMap() {
      const srcToDestAnnsetMap = {};
      this.sourceAnnsets.forEach((set) => {
        // destAnnsetMap[set] = this.sourceDS.annotation_sets.find((s) => s.id === set);
        if (!this.destDS?.annotation_sets) {
          // No dest dataset, so create new annotation set
          srcToDestAnnsetMap[set] = '';
        } else if (this.srcToDestAnnsetMap[set]) {
          // Use the same map as before
          srcToDestAnnsetMap[set] = this.srcToDestAnnsetMap[set];
        } else {
          const foundAnnSet = this.destDS.annotation_sets.find((dAnnSet) => dAnnSet.name === this.sourceIdToAnnsetMap[set].name);
          if (foundAnnSet) {
            // Found an annotation set with same name
            srcToDestAnnsetMap[set] = foundAnnSet.id;
          } else {
            // No annotation set with same name, so create new annotation set
            srcToDestAnnsetMap[set] = '';
          }
        }
      });
      this.srcToDestAnnsetMap = srcToDestAnnsetMap;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/themes/auzone/buttons.scss';
#copy-form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 0 3rem;
  margin: 0.75rem 0;
  overflow: auto;
  position: relative;
}

@media (min-width: $breakpoint-sm) {
  #copy-form {
    width: 850px;
  }
}

.copy-card {
  display: flex;
  flex-direction: column;
  background: var(--color-white-100);
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--color-primary-100);
}

.help-tooltip {
  position: absolute;
  top: 1rem;
  right: 3.25rem;
}

.tooltip-text{
  span {
    width: 100%;
    word-wrap: break-word;
  }
}

.dest-set-selector-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 4px;
}

.dest-set-selector {
  .annotation-set-select {
    margin-top: auto;
    margin-bottom: auto;
  }

  .percent-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    width: 120px;
    min-width: 120px;
    height: 100%;
  }

  .remove-dest-ds-button {
    margin-right: 10px;
    visibility: hidden;
  }

  &:hover {
    background-color: rgb(237, 232, 232);
  }

  &:hover .remove-dest-ds-button {
      z-index: 3;
    visibility: visible;
    @include themify() {
      color: themed('icon-color-inactive');
    }
  }

  &:hover .remove-dest-ds-button:hover {
      z-index: 3;
    visibility: visible;
    @include themify() {
      color: themed('icon-color-primary');
    }
  }
}

.result {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  font-size: 1rem;
  font-weight:600;
  padding: 3px 10px;
  align-items: center;
  justify-content: center;
}

.result-container {
  justify-content: center;
}

.success {
  text-align: left;
  @include themify() {
    background: rgba(115, 206, 115, 0.5) ;
    color: themed('color-success');
    border: 1px solid themed('color-success');
  }
}

.error {
  @include themify() {
    background: rgba(182, 94, 94, 0.5) ;
    color: themed('color-error');
    border: 1px solid themed('color-error');
  }
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5px 0;
  @include themify() {
    background: rgba(230, 221, 239, 0.5) ;
    color: var(--color-primary-500);
    border: 1px solid var(--color-primary-500);
  }
}

.merger-loader {
  width: 60px !important;
  height: 60px !important;
}

.random-input {
  width: 70px;
  height: 30px;
  background: #ffffff;
  border-radius: 5px;
  font-size: 1rem;
  padding: 3px 10px;
  margin-left: 5px;
  margin-right: 5px;
  align-self: center;
  appearance: auto;
  -webkit-appearance: auto;
  @include themify() {
    border: 1px solid themed('text-input-border-color');
  }
}

.destination-header {
  display: flex;
  flex-direction: row;
  align-items: center;

  .add-dataset-icon {
    visibility: visible;
    margin-left: 6px;
    @include themify() {
      color: themed('icon-color-inactive');
    }
  }

  .add-dataset-icon:hover {
    @include themify() {
      color: themed('icon-color-primary');
    }
  }

}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0rem 3rem 0.75rem 3rem;
  justify-content: flex-end;
}

.settings__control-group {
  align-items: flex-start;
  min-width: 200px;

  :deep(.filter-button) {
    width: 100%;
    height: 100%;
  }
}

.checkbox-text-label {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
}

.annotation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  width: 100%;
  gap: 5px;
  padding: 5px;
  max-height: 500px;
  overflow-y: auto;
}

.help-icon {
  margin: 0 5px;
  color: var(--color-primary);
}

.help-icon:focus {
  outline: none;
}

.annotation-set-map {
  display: flex;

  &__row {
    flex-wrap: nowrap;
    max-width: 100%;
    align-items: center;
    & > svg {
      width: fit-content;
    }

    // & > * {
    //   width: fit-content;
    // }
  }

  &__dest {
    flex: 1 1 auto;
  }
}

.file-grid {
  display: grid;
  grid-template-columns: calc(25% - 10px) calc(25% - 10px) calc(25% - 10px) calc(25% - 10px);
  width: 100%;
  flex: 1 1 auto;
  gap: 10px;
  padding: 5px;
  overflow-y: auto;
  margin-left: 10px;

  &__cell {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    padding: 5px;
    height: 30px;
    border-radius: 8px;
    background-color: var(--color-white-800);
    align-items: center;
    justify-content: space-between;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

</style>
